import React from 'react';
import FranchiseTableTab from '../../components/Franchise/Network';

export default function FranchisePage() {
	return <FranchiseTableTab />;
}
